<template lang="pug">
.content-center
  .sticky-top
    .bets-wrap
      .headline-bar
        .prematch.d-flex.align-items-center(@click="backHome()")
          div(:class="mode == 1 && selectedId ? 'yellow-link' : ''") {{ $t("ui.sysparlay") }}
          template(v-if="mode == 1 && selectedId")
            span.d-inline-block.px-2
              i.fal.fa-chevron-right
            | {{ selectedId }}
      ul.d-flex(v-if="mode == 0")
        li.flex-grow-1
          a(:class="{'active': currentDate == 12}" @click="setDate(12)") {{ $t("ui.today") }}
        li.flex-grow-1
          a(:class="{'active': currentDate == 36}" @click="setDate(36)") {{ $t("ui.yesterday") }}
    .message-filter(v-if="mode == 0")
      .input-group.mr-1
        date-picker.form-control.datepicker(v-model="fromDate" :config="locale" @input="getReport()")
        .input-group-append
          span.input-group-text
            i.fas.fa-calendar-alt
      .input-group.mr-0.ml-1
        date-picker.form-control.datepicker(v-model="toDate" :config="locale" @input="getReport()")
        .input-group-append
          span.input-group-text
            i.fas.fa-calendar-alt
  .pagepanel
    .page-group
      #sysparlay.statement-group
        .statement-wrap
          template(v-if="this.feedback.loading")
            .no-data
              .no-data-wrapper
                .loading-wrap
                  .loading
                    .block
                    .block
                    .block
                  .text {{ $t("ui.loading") }}
          template(v-else)
            template(v-if="mode == 0")
              template(v-if="data1 != null && data1.length > 0")
                .pagination-wrapper(v-if="mode == 0 && data1 != null && data1.length > 0")
                  v-pagination(
                    v-model="page_number"
                    :page-count="page_total"
                    :classes="bootstrapPaginationClasses"
                    :labels="paginationAnchorTexts"
                    @input="changedPage1($event)"
                    v-if="page_total"
                  )
                .bet-slip(v-for="(item, index) in data1")
                  .stake-info-wrapper
                    .bet-type.d-flex.justify-content-between
                      span.date {{ $dayjs(item.created_on).format("MM/DD/YYYY hh:mm:ss A") }}
                      a.refno-link(@click="view2(item.system_parlay_id)")
                        | {{ $t("ui.ref_no") }}: {{ item.system_parlay_id }}
                        i.fas.fa-chevron-square-right.ml-1
                    .stake-info
                      .betslip-system-parlay
                        .matches {{ item.total_match }} {{ $t("ui.matches") }}
                        .fold {{ item.fold }} {{ $t("ui.fold") }}
                        .combination {{ item.combination }} {{ $t("ui.combinations") }}
                  .footer-slip.text-left
                    .payout-wrapper
                      .left.mr-1
                        | {{ $t("ui.stake_per_bet") }}:
                        span {{ $numeral(item.bet_member).format("0,0.00") }}
                  .parlay-inner-layer.collapse(:id="'sysparlay-child-' + item.system_parlay_id" data-parent="#sysparlay")
                    template(v-if="data2 != null && data2.length > 0")
                      template(v-for="(parlay, index) in data2")
                        .bet-slip-inner
                          .stake-info-wrapper
                            template(v-if="$helpers.showWinStatus(parlay) == $t('ui.lose') || $helpers.showWinStatus(parlay) == $t('ui.lose_half')")
                              .bet-status.lose
                                span {{ $helpers.showWinStatus(parlay) }}
                            template(v-else-if="[$t('ui.draw_cancel'),$t('ui.cancel'),$t('ui.void'),$t('ui.abandoned')].includes($helpers.showWinStatus(parlay))")
                              .bet-status.draw
                                span {{ $helpers.showWinStatus(parlay) }}
                            template(v-else-if="$helpers.showWinStatus(parlay) == $t('ui.win') || $helpers.showWinStatus(parlay) == $t('ui.win_half')")
                              .bet-status.won
                                span {{ $helpers.showWinStatus(parlay) }}
                            template(v-else)
                              .bet-status.blank
                                span {{ $helpers.showWinStatus(parlay) }}
                            .bet-league
                              img.icon.mr-1(:src="'/images/icon-sport-svg/' + getSportsImage(parlay)")
                              | {{ sports[parlay.sports_type] }} - {{ betType(parlay) }}
                            .stake-info
                              .betslip-match
                                .team-involved
                                  .score(v-if="parlay.home_score != null") {{ parlay.home_score + "-" + parlay.away_score }}
                                  span(:class="parlay.home_giving == 1 && isBallDisplay(parlay) ? 'team2' : 'team1'") {{ getName(parlay, 0) }}
                                  span.vs - VS -
                                  span(:class="parlay.home_giving == 0 && isBallDisplay(parlay) ? 'team2' : 'team1'") {{ getName(parlay, 1) }}
                              .selector-odd.d-flex.justify-content-between
                                span.text {{ parlay.bet_type }} | {{ betDisplay(parlay) }}
                                .bet-type-odds
                                  span.bet-type-text(v-if="['HDP', 'HDPH', 'OU', 'OUH', '1X2HDP', '1X2HDPH'].includes(parlay.bet_type)") {{ ballDisplay(parlay) }}
                                  .odds
                                    //- | @
                                    span(:class="getNumberClass(parlay.odds_display)") {{ parlay.odds_display }}
                          .bet-details-important.p-2
                            .bet-details-league.text-center.text-uppercase {{ getName(parlay, 2) }}
                  .btn-more-detail(:id="'sysparlay-child-btn-' + item.system_parlay_id" data-toggle='collapse' :data-target="'#sysparlay-child-' + item.system_parlay_id" aria-expanded='false' :aria-controls="'sysparlay-child-' + item.system_parlay_id" @click="showDetail(item.system_parlay_id)") {{ $t("ui.more_details") }}
                .pagination-wrapper(v-if="mode == 0 && data1 != null && data1.length > 0")
                  v-pagination(
                    v-model="page_number"
                    :page-count="page_total"
                    :classes="bootstrapPaginationClasses"
                    :labels="paginationAnchorTexts"
                    @input="changedPage1($event)"
                    v-if="page_total"
                  )
              template(v-else)
                .no-data
                  .no-data-wrapper
                    img(src='/images/no_data.svg?v=12')
                    span.text {{ $t("ui.no_record") }}
            template(v-else-if="mode == 1")
              template(v-if="data3 != null && data3.length > 0")
                .pagination-wrapper(v-if="mode == 1 && data3 != null && data3.length > 0")
                  v-pagination(
                    v-model="page_number2"
                    :page-count="page_total2"
                    :classes="bootstrapPaginationClasses"
                    :labels="paginationAnchorTexts"
                    @input="changedPage2($event)"
                    v-if="page_total2"
                  )
                .bet-slip.parlay(v-for="(combo, index) in data3")
                  .stake-info-wrapper
                    template(v-if="['rejected','void'].includes(combo.bet_status.toLowerCase())")
                      .bet-status.lose
                        span {{ $t("ui." + combo.bet_status.toLowerCase()) }}
                    template(v-if="combo.bet_status.toLowerCase() == 'accepted'")
                      .bet-status.won
                        span {{ $t("ui." + combo.bet_status.toLowerCase()) }}
                    template(v-if="combo.bet_status.toLowerCase() == 'pending'")
                      .bet-status.pending
                        span {{ $t("ui." + combo.bet_status.toLowerCase()) }}
                    .bet-league
                      | {{ $t("ui.ref_no") }}: {{ combo.bet_id }}
                    .stake-info.p-0
                      //- .date 05/11/2021 01:51:30 PM
                      .betslip-match.m-0
                        .selector-odd.d-flex.justify-content-center
                          span.text.pt-1 {{ $t("m.BT_PARLAY") }}
                          .bet-type-odds
                            .odds
                              //- | @
                              span {{ combo.odds_display }}
                  .footer-slip.text-left
                    .payout-wrapper
                      .left
                        | {{ $t("ui.stake") }}:
                        span.ml-1 {{ $numeral(combo.bet_member).format("0,0.00") }}
                      .right
                        | {{ $t("ui.winlose") }}:
                        span.ml-1(v-if="combo.winlose" :class="getNumberClass1(combo.winlose)") {{ $numeral(combo.winlose).format("0,0.00") }}
                        span.ml-1(v-else) -
                  .parlay-inner-layer.collapse(:id="'sysparlay-combo-' + combo.bet_id" data-parent="#sysparlay")
                    template(v-if="data4 != null && data4.length > 0")
                      template(v-for="(match, index) in data4")
                        .bet-slip-inner
                          .stake-info-wrapper
                            template(v-if="$helpers.showWinStatus(match) == $t('ui.lose') || $helpers.showWinStatus(match) == $t('ui.lose_half')")
                              .bet-status.lose
                                span {{ $helpers.showWinStatus(match) }}
                            template(v-else-if="[$t('ui.draw_cancel'),$t('ui.cancel'),$t('ui.void'),$t('ui.abandoned')].includes($helpers.showWinStatus(match))")
                              .bet-status.draw
                                span {{ $helpers.showWinStatus(match) }}
                            template(v-else-if="$helpers.showWinStatus(match) == $t('ui.win') || $helpers.showWinStatus(match) == $t('ui.win_half')")
                              .bet-status.won
                                span {{ $helpers.showWinStatus(match) }}
                            template(v-else)
                              .bet-status.blank
                                span {{ $helpers.showWinStatus(match) }}
                            .bet-league
                              img.icon(:src="'/images/icon-sport-svg/' + getSportsImage(match)")
                              | {{ sports[match.sports_type] }} - {{ betType(match) }}
                            .stake-info
                              .betslip-match
                                .team-involved
                                  span(:class="match.home_giving == 1 && isBallDisplay(match) ? 'team2' : 'team1'") {{ getName(match, 0) }}
                                  span.vs - VS -
                                  span(:class="match.home_giving == 0 && isBallDisplay(match) ? 'team2' : 'team1'") {{ getName(match, 1) }}
                              .selector-odd.d-flex.justify-content-between
                                span.text {{ match.bet_type }} | {{ betDisplay(match) }}
                                .bet-type-odds
                                  span.bet-type-text(v-if="['HDP', 'HDPH', 'OU', 'OUH', '1X2HDP', '1X2HDPH'].includes(match.bet_type)") {{ ballDisplay(match) }}
                                  span.mr-1(v-if="match.market_type == 3 && match.home_running_score != null") [{{ match.home_running_score + "-" + match.away_running_score }}]
                                  .odds
                                    //- | @
                                    span(:class="getNumberClass(match.odds_display)") {{ match.odds_display }}
                          .bet-details-important
                            .bet-details-league.text-center.text-uppercase {{ getName(match, 2) }}
                  .btn-more-detail.btn-combo(:id="'sysparlay-combo-btn-' + combo.bet_id" data-toggle='collapse' :data-target="'#sysparlay-combo-' + combo.bet_id" aria-expanded='false' :aria-controls="'sysparlay-combo-' + combo.bet_id" @click="showDetail1(combo)") {{ $t("ui.more_details") }}
                .bet-slip
                  .stake-info-wrapper
                    .stake-info
                      .settlement-amount.d-flex.justify-content-between
                        .text-left
                          div
                            | {{ $t("ui.total") }}:
                            span.accept-text.font-weight-bold.ml-1 {{ data3[0].total_accept }} {{ $t("ui.accepted") }}
                          div
                            | {{ $t("ui.total") }}:
                            span.reject-text.font-weight-bold.ml-1 {{ data3[0].total_reject }} {{ $t("ui.rejected") }}
                        .text-right
                          div
                            | {{ $t("ui.total_stake") }}:
                            span.font-weight-bold.ml-1 {{ $numeral(data3[0].sum_bet).format("0,0.00") }}
                          div
                            | {{ $t("ui.total_winlose") }}:
                            span.font-weight-bold.ml-1(v-if="data3[0].pending==0" :class="getNumberClass2(data3[0].sum_wl)") {{ $numeral(data3[0].sum_wl).format("0,0.00") }}
                            span.font-weight-bold.ml-1(v-else) -
                .pagination-wrapper(v-if="mode == 1 && data3 != null && data3.length > 0")
                  v-pagination(
                    v-model="page_number2"
                    :page-count="page_total2"
                    :classes="bootstrapPaginationClasses"
                    :labels="paginationAnchorTexts"
                    @input="changedPage2($event)"
                    v-if="page_total2"
                  )
              template(v-else)
                .no-data
                  .no-data-wrapper
                    img(src='/images/no_data.svg?v=12')
                    span.text {{ $t("ui.no_record") }}
</template>


<script>
import config from "@/config";
import errors from "@/errors";
import statement from "@/library/_xhr-statement";
import vPagination from "vue-plain-pagination";
import naming from "@/library/_name";
import xhr from "@/library/_xhr-betlist.js";
import { EventBus } from "@/library/_event-bus.js";

export default {
  components: {
    vPagination
  },
  data() {
    return {
      mode: 0,
      // loading: false,
      selectedId: null,
      feedback: {
        loading: false,
        success: false,
        status: errors.session.invalidSession
      },
      locale: {
        format: "YYYY-MM-DD",
        useCurrent: true,
        minDate: this.$dayjs(this.$dayjs().startOf("day").subtract(14, "days").format("YYYY-MM-DD", config.timeZone)).format("YYYY-MM-DD"),
        maxDate: this.$dayjs().format("YYYY-MM-DD", config.timeZone)
      },
      currentDate: null,
      start_date: null,
      end_date: null,
      page_number: 1,
      page_size: 10,
      page_total: 10,
      page_number2: 1,
      page_size2: 10,
      page_total2: 10,
      bootstrapPaginationClasses: {
        ul: "pagination justify-content-center",
        li: "page-item",
        liActive: "active",
        liDisable: "disabled",
        button: "page-link",
        buttonActive: "active",
        buttonDisable: "disable"
      },
      paginationAnchorTexts: {
        first: "&laquo;",
        prev: "&lsaquo;",
        next: "&rsaquo;",
        last: "&raquo;"
      },
      data1: [],
      data2: [],
      data3: [],
      data4: [],
      data5: [],
      parlayItems: [],
      leagueList: [],
      matchList: []
    };
  },
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    whiteLabel() {
      return config.whiteLabel == "1";
    },
    fromDate: {
      get() {
        if (this.start_date) return this.start_date;
        else
          return this.$dayjs()
            .subtract("12", "hours")
            .subtract("7", "days")
            .format("YYYY-MM-DD", config.timeZone);
      },
      set(value) {
        this.start_date = value;
      }
    },
    toDate: {
      get() {
        if (this.end_date) return this.end_date;
        else
          return this.$dayjs()
            .add("12", "hours")
            .format("YYYY-MM-DD", config.timeZone);
      },
      set(value) {
        this.end_date = value;
      }
    },
    sports() {
      return this.$store.state.layout.sports;
    },
    language() {
      return this.$store.getters.language;
    },
  },
  watch: {
    // selected(val) {
    //   this.resultList = [];
    //   this.getResult(val === "OR");
    // }
  },
  mounted() {
    // this.getResult(false);
    // EventBus.$on("SYSPARLAY_REFRESH", this.refreshReport);
    this.backHome();
  },
  methods: {
    view2(e) {
      this.mode = 1;
      this.selectedId = e;
      this.page_number2 = 1;
      this.page_size2 = parseInt(this.getPageSize);
      this.page_total2 = 10;
      this.getBet(e, true);
    },
    backHome() {
      this.mode = 0;
      this.selectedId = null;
      this.page_number = 1;
      this.page_size = parseInt(this.getPageSize);
      this.page_total2 = 10;
      this.getReport();
    },
    changedPage1(pageNo) {
      this.page_number = pageNo;
      this.getReport();
    },
    changedPage2(pageNo) {
      this.page_number2 = pageNo;
      this.getBet(this.selectedId, true);
    },
    refreshReport() {
      if (this.mode == 0) {
        this.getReport();
      } else {
        if (this.selectedId) {
          this.getBet(this.selectedId, true);
        }
      }
    },
    setDate(offset) {
      if(offset == 12) {
        this.currentDate = 12
      } else {
        this.currentDate = 36
      }
      this.fromDate = this.$dayjs()
        .subtract(offset, "hours")
        .format("YYYY-MM-DD", config.timeZone);
      this.toDate = this.$dayjs()
        .subtract(offset - 12, "hours")
        .format("YYYY-MM-DD", config.timeZone);
    },
    getName(e, mode) {
      switch(mode) {
        case 0: //home
          var r = e["home_name_" + this.language];
          if (r != null && r != "") {
            return r;
          }
          return e.home_name_en
        case 1: //away
          var r = e["away_name_" + this.language];
          if (r != null && r != "") {
            return r;
          }
          return e.away_name_en
        case 2: //league
          var r = e["name_" + this.language];
          if (r != null && r != "") {
            return r;
          }
          return e.league_name;
      }
    },
    getBet(e, loading) {
      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        system_parlay_id: e,
        page_number: this.page_number2,
        page_size: this.page_size
      };

      this.feedback.loading = true;
      this.data3 = [];

      statement.getBetParlayBet(json).then(
        result => {
          this.feedback.loading = false;
          if (result) {
            this.feedback.status = result.status;
            if (result.success == true) {
              this.data3 = result.data;
              if (this.data3 == null) {
                this.page_total2 = 1;
              } else {
                if (this.data3.length <= 0) {
                  this.page_total2 = 1;
                } else {
                  var totalrows = this.data3[0].totalrows;
                  if (totalrows % this.page_size2 != 0) this.page_total2 = Math.ceil(parseFloat(totalrows) / parseFloat(this.page_size2));
                  else this.page_total2 = parseFloat(totalrows) / parseFloat(this.page_size2);
                }
              }
            } else {
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        },
        err => {
          if (loading) this.feedback.loading = false;
          this.feedback.success = false;
          this.feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    },
    getMatch(e) {
      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        system_parlay_id: e
      };

      // this.feedback.loading = true;
      this.data2 = [];

      statement.getBetParlayMatch(json).then(
        result => {
          this.feedback.loading = false;
          if (result) {
            this.feedback.status = result.status;
            if (result.success == true) {
              this.data2 = result.data;
            } else {
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        },
        err => {
          this.feedback.success = false;
          this.feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    },
    getReport() {
      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        start_date: this.fromDate,
        end_date: this.toDate,
        page_number: this.page_number,
        page_size: this.page_size
      };

      this.feedback.loading = true;
      this.data1 = [];

      statement.getBetParlay(json).then(
        result => {
          this.feedback.loading = false;
          if (result) {
            this.feedback.status = result.status;
            if (result.success == true) {
              this.data1 = result.data;
              if (this.data1 == null) {
                this.page_total = 1;
              } else {
                if (this.data1.length <= 0) {
                  this.page_total = 1;
                } else {
                  var totalrows = this.data1[0].totalrows;
                  if (totalrows % this.page_size != 0) this.page_total = Math.ceil(parseFloat(totalrows) / parseFloat(this.page_size));
                  else this.page_total = parseFloat(totalrows) / parseFloat(this.page_size);
                }
              }
            } else {
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        },
        err => {
          this.feedback.loading = false;
          this.feedback.success = false;
          this.feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    },
    getMatchStatus(ht, ft) {
      return naming.matchStatus(ht, ft);
    },
    showDetail(parlayID) {
      let id = "#sysparlay-child-btn-" + parlayID
      let isActive = $(id).hasClass('active')
      if($(".btn-more-detail").hasClass('active')) {
        $(".btn-more-detail").removeClass('active').text(this.$t("ui.more_details"))
      }

      if(isActive) {
        $(id).removeClass('active').text(this.$t("ui.more_details"))
      } else {
        $(id).addClass('active').text(this.$t("ui.hide"))
        this.getMatch(parlayID)
      }
    },
    showDetail1(combo) {
      let id = "#sysparlay-combo-btn-" + combo.bet_id
      let isActive = $(id).hasClass('active')
      if($(".btn-combo").hasClass('active')) {
        $(".btn-combo").removeClass('active').text(this.$t("ui.more_details"))
      }

      if(isActive) {
        $(id).removeClass('active').text(this.$t("ui.more_details"))
      } else {
        $(id).addClass('active').text(this.$t("ui.hide"))
        this.getDetails(combo)
      }
    },
    getDetails(e, loading) {
      if (e.bet_status.toLowerCase() == "accepted") {
        this.getAccepted(e.bet_id, loading);
      } else {
        this.getRejected(e.bet_id, loading);
      }
    },
    getAccepted(e, loading) {
      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        bet_id: e
      };
      if (loading) this.feedback.loading = true;
      this.data4 = [];

      xhr.getParlayAcceptDetails(json).then(
        result => {
          if (loading) this.feedback.loading = false;
          if (result) {
            this.feedback.status = result.status;
            if (result.success == true) {
              this.data4 = result.data;
            } else {
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        },
        err => {
          if (loading) this.feedback.loading = false;
          this.feedback.success = false;
          this.feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    },
    getRejected(e, loading) {
      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        bet_id: e
      };
      if (loading) this.feedback.loading = true;
      this.data4 = [];

      xhr.getParlayRejectDetails(json).then(
        result => {
          if (loading) this.feedback.loading = false;
          if (result) {
            this.feedback.status = result.status;
            if (result.success == true) {
              this.data4 = result.data;
            } else {
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        },
        err => {
          if (loading) this.feedback.loading = false;
          this.feedback.success = false;
          this.feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    },
    isBallDisplay(match) {
      var result = naming.ballDisplay2(match.ball_display, match.home_giving, match.home_away, match.bet_type, this);
      if (["HDP", "HDPH"].includes(match.bet_type)) {
        return result != null && result != "0";
      } else {
        return false;
      }
    },
    getSportsImage(e) {
      if(e.sports_type == -1 || e.sports_type == 0) {
        e.sports_type = 1
      }
      return config.getSportsImage(e.sports_type);
    },
    betType(e) {
      var label = ""
      if(e.bet_type == 'PARLAY') {
        label = e.total_match > 0 ? this.$t("ui.folds_" + e.total_match) : this.$t("m.BT_" + e.bet_type);
      } else {
        label = this.$t("m.BS_" + e.bet_type);
      }
      return label;
    },
    betDisplay(e) {
      return naming.betDisplay(e, this);
    },
    ballDisplay(e) {
      // return naming.ballDisplay(e, this);
      if(e.ball_display) {
        return naming.ballDisplay2(e.ball_display, e.home_giving, e.home_away, e.bet_type, this);
      } else {
        return naming.ballDisplay1(e, this);
      }
    },
    getNumberClass(e) {
      return parseFloat(e) >= 0 ? "" : "negetive";
    },
    getNumberClass1(e) {
      return parseFloat(e) == 0 ? "" : parseFloat(e) > 0 ? "win-amount" : "lose-amount";
    },
    getNumberClass2(e) {
      return parseFloat(e) == 0 ? "" : parseFloat(e) > 0 ? "accept-text" : "lose-text";
    },
    getParlayDetails(result_id) {
      if (this.loading == true) return;

      if (this.isLoggedIn) {
        this.loading = true;
        this.data4 = [];

        var json = {
          account_id: this.$store.getters.accountId,
          session_token: this.$store.getters.sessionToken,
          bet_id: result_id
        };

        switch (this.status) {
          case "running":
            xhr.getParlayAcceptDetails(json).then(
              res => {
                this.loading = false;
                if (res) {
                  if (res.success == true) {
                    this.data4 = res.data;
                  } else {
                    this.$helpers.handleFeedback(res.status, res.source);
                  }
                }
              },
              err => {
                this.loading = false;
                this.$helpers.handleFeedback(err.status, err.source);
              }
            );
            break;
          case "waiting":
            xhr.getParlayPendingDetails(json).then(
              res => {
                this.loading = false;
                if (res) {
                  if (res.success == true) {
                    this.data4 = res.data;
                  } else {
                    this.$helpers.handleFeedback(res.status, res.source);
                  }
                }
              },
              err => {
                this.loading = false;
                this.$helpers.handleFeedback(err.status, err.source);
              }
            );
            break;
          case "rejected":
            xhr.getParlayRejectDetails(json).then(
              res => {
                this.loading = false;
                if (res) {
                  if (res.success == true) {
                    this.data4 = res.data;
                  } else {
                    this.$helpers.handleFeedback(res.status, res.source);
                  }
                }
              },
              err => {
                this.loading = false;
                this.$helpers.handleFeedback(err.status, err.source);
              }
            );
            break;
          default:
            service.getParlayDetails(json).then(
              res => {
                this.loading = false;
                if (res) {
                  if (res.success == true) {
                    this.data4 = res.data;
                    // this.matchList = res.names["Table"];
                    // this.leagueList = res.names["Table1"];
                  } else {
                    this.$helpers.handleFeedback(res.status, res.source);
                  }
                }
              },
              err => {
                this.loading = false;
                this.$helpers.handleFeedback(err.status, err.source);
              }
            )
            break;
        }
      }
    }
  }
};
</script>
